export default __webpack_public_path__ + "static/media/SemanaNordica_Agenda_Martes_eng.484fe188.png";